<div class="rec-container ">
  <h2>Search Recorded Land by Value</h2>
  <!--<h3><font color="red">In Progress</font></h3>-->
  <form (ngSubmit)="onSubmit($event)" #f="ngForm">
    <div class="doc-cat-container">
      <app-doc-category-vs></app-doc-category-vs>
    </div>
    <div class="amount-container" [ngStyle]="{'height': (screenWidth > 768) ? '123px' : amountRangeChild.utilityobj.type != 'rng' ? '147px' : '230px'}">
      <app-amountrange></app-amountrange>
    </div>
    <div class="date-container">
      <!--<app-daterange></app-daterange>-->
      <lib-date-range-parent></lib-date-range-parent>
    </div>
    <div class="city-container">
      <app-city-town-ex></app-city-town-ex>
    </div>
    <button class="btn btn-default" type="submit">
      SEARCH
    </button>

    <!--<button class="btn btn-default" type="button" (click)="search('/rec-value-result-pg')">
    SEARCH
  </button>-->
  </form>
</div>
